"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var popover_scss_1 = tslib_1.__importDefault(require("./popover.scss"));
var key_codes_1 = tslib_1.__importDefault(require("../../constants/key-codes"));
var scrollbar_wrapper_1 = tslib_1.__importDefault(require("../scrollbar-wrapper/scrollbar-wrapper"));
var withStyles_1 = require("../../utils/withStyles");
var Popover = /** @class */ (function (_super) {
    tslib_1.__extends(Popover, _super);
    function Popover(props) {
        var _this = _super.call(this, props) || this;
        _this.closingPromise = Promise.resolve();
        _this.handleWindowBlur = function () {
            if (_this.props.isOpen) {
                return;
            }
            _this.setIsOpen(false);
        };
        _this.handleDocumentClick = function (event) {
            if (!_this.containerRef) {
                return;
            }
            if (!_this.containerRef.contains(event.target)) {
                if (_this.state.isOpen) {
                    _this.setIsOpen(false);
                }
            }
        };
        _this.handleDocumentKeyPress = function (event) {
            if (!_this.containerRef) {
                return;
            }
            if (event.keyCode === key_codes_1.default.ESC) {
                if (_this.containerRef.contains(event.target)) {
                    _this.setOpenFromKeyboard(false);
                    return;
                }
                _this.setIsOpen(false);
            }
        };
        _this.handleKeyDown = function (event) {
            if (lodash_1.includes([key_codes_1.default.DOWN, key_codes_1.default.UP, key_codes_1.default.SPACE, key_codes_1.default.ENTER], event.keyCode)) {
                event.preventDefault();
                if (!_this.state.isOpen) {
                    _this.setOpenFromKeyboard(true);
                }
            }
        };
        _this.setOpenFromKeyboard = function (isOpen) {
            _this.setIsOpen(isOpen, function () {
                if (isOpen) {
                    if (_this.contentRef && _this.props.focusContentOnOpen) {
                        _this.contentRef.childNodes[0].focus();
                    }
                }
                else {
                    if (_this.openerRef) {
                        _this.openerRef.focus();
                    }
                }
            });
        };
        _this.toggleOpen = function (event) {
            if (event.type === 'mousedown' && event.button === 0) {
                event.preventDefault();
                _this.setIsOpen(!_this.state.isOpen);
            }
        };
        _this.saveRef = function (refName) { return function (ref) { return (_this[refName] = ref); }; };
        _this.handleContentKeydown = function (event) {
            if (lodash_1.includes([key_codes_1.default.SPACE, key_codes_1.default.ENTER], event.keyCode)) {
                event.preventDefault();
                _this.setOpenFromKeyboard(false);
            }
        };
        _this.state = {
            isOpen: props.isOpen,
            isClosing: false,
        };
        return _this;
    }
    Popover.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleDocumentClick, false);
        document.addEventListener('keydown', this.handleDocumentKeyPress, false);
        window.addEventListener('blur', this.handleWindowBlur, false);
    };
    Popover.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleDocumentClick, false);
        document.removeEventListener('keydown', this.handleDocumentKeyPress, false);
        window.removeEventListener('blur', this.handleWindowBlur, false);
    };
    Popover.prototype.UNSAFE_componentWillReceiveProps = function (_a) {
        var isOpen = _a.isOpen;
        if (isOpen !== this.props.isOpen) {
            this.setIsOpen(isOpen);
        }
    };
    Popover.prototype.setIsOpen = function (isOpen, onStateChanged) {
        var _this = this;
        if (onStateChanged === void 0) { onStateChanged = lodash_1.noop; }
        this.closingPromise.then(function () {
            _this.setState({ isClosing: !isOpen });
            if (isOpen) {
                _this._setIsOpen(isOpen, onStateChanged);
                return;
            }
            _this.closingPromise = new Promise(function (resolve) {
                return setTimeout(resolve, 300);
            }).then(function () {
                _this._setIsOpen(isOpen, onStateChanged);
            });
        });
    };
    Popover.prototype._setIsOpen = function (isOpen, onStateChanged) {
        this.setState({ isOpen: isOpen, isClosing: false }, onStateChanged);
        this.props.onToggle(isOpen);
    };
    Popover.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, content = _b.content, children = _b.children, dataHook = _b.dataHook, isFocusable = _b.isFocusable, ariaRole = _b.ariaRole, ariaLabel = _b.ariaLabel, openerClassName = _b.openerClassName, isRTL = _b.isRTL;
        var _c = this.state, isOpen = _c.isOpen, isClosing = _c.isClosing;
        return (react_1.default.createElement("div", { ref: this.saveRef('containerRef'), "data-hook": "popover-container", className: popover_scss_1.default.container },
            react_1.default.createElement("div", { role: ariaRole, className: openerClassName, "aria-label": ariaLabel, "aria-haspopup": "true", "aria-expanded": isOpen, ref: this.saveRef('openerRef'), onKeyDown: this.handleKeyDown, onMouseDown: this.toggleOpen, tabIndex: isFocusable ? 0 : -1, "data-hook": dataHook }, children),
            react_1.default.Children.count(content) > 0 && (react_1.default.createElement(scrollbar_wrapper_1.default, { dataHook: "popover-content", className: classnames_1.default(popover_scss_1.default.content, className, (_a = {},
                    _a[popover_scss_1.default.open] = isOpen,
                    _a[popover_scss_1.default.closing] = isClosing,
                    _a[popover_scss_1.default.rtl] = isRTL,
                    _a[popover_scss_1.default.ltr] = !isRTL,
                    _a)) },
                react_1.default.createElement("div", { ref: this.saveRef('contentRef'), "aria-hidden": !isOpen, onMouseDown: this.toggleOpen, onKeyDown: this.handleContentKeydown }, isOpen && content)))));
    };
    Popover.defaultProps = {
        isFocusable: true,
        onToggle: lodash_1.noop,
        ariaRole: 'button',
        dataHook: 'open-popover',
        focusContentOnOpen: true,
        isOpen: false,
    };
    Popover = tslib_1.__decorate([
        withStyles_1.withStyles(popover_scss_1.default)
    ], Popover);
    return Popover;
}(react_1.default.Component));
exports.default = Popover;
//# sourceMappingURL=popover.js.map